var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwesomeSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.12,
    height: 29.12,
    viewBox: "0 0 29.12 29.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-save",
    "data-name": "Icon awesome-save",
    d: "M28.206,8.616,22.754,3.164a3.12,3.12,0,0,0-2.206-.914H3.12A3.12,3.12,0,0,0,0,5.37V28.25a3.12,3.12,0,0,0,3.12,3.12H26a3.12,3.12,0,0,0,3.12-3.12V10.822a3.12,3.12,0,0,0-.914-2.206ZM14.56,27.21a4.16,4.16,0,1,1,4.16-4.16A4.16,4.16,0,0,1,14.56,27.21ZM20.8,7.416V13.95a.78.78,0,0,1-.78.78H4.94a.78.78,0,0,1-.78-.78V7.19a.78.78,0,0,1,.78-.78H19.794a.78.78,0,0,1,.552.228l.226.226a.78.78,0,0,1,.228.552Z",
    transform: "translate(0 -2.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwesomeSave);
export default __webpack_public_path__ + "static/media/awesome-save.215d7a437528537d6818702727f44558.svg";
export { ForwardRef as ReactComponent };